export const minRule = 'validation.min.string.password'
export const maxRule = 'validation.max.string.password'
export const oneUpperRule = 'validation.one_uppercase_character.password'
export const oneLowerRule = 'validation.one_lowercase_character.password'
export const oneSymbolOrNumberRule = 'validation.one_symbol_or_number.password'
export const policyRule = 'validation.password_policy.password'
export const emailPasswordRule = 'validation.email_password_same.password'

export const passwordCriteria = [
  { rule: minRule, message: 'have 8 characters or more' },
  { rule: maxRule, message: 'too long' },
  {
    rule: oneUpperRule,
    message: 'contain at least one uppercase letter (A-Z)',
  },
  {
    rule: oneLowerRule,
    message: 'contain at least one lowercase letter (a-z)',
  },
  {
    rule: oneSymbolOrNumberRule,
    message: 'contain at least one number (0-9) or symbol',
  },
  { rule: policyRule, message: 'not be a common word' },
  { rule: emailPasswordRule, message: 'be different to the email address' },
]
